import CTNButton from '@ctn/ui/components/ctn-button';
import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';

import TextIcon from '@/components/TextIcon';

import { type IUserListado } from '@/interfaces/model/user.interface';
import { getFullName } from '@/utils/string/string';
import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';


const getColumns = ({ onEdit }: { onEdit: (value: IUserListado) => void }) => {
	const columns: Array<CustomColumnDef<IUserListado>> = [
		{
			accessorKey: 'nombre',
			header: 'Nombre',
			enableSorting: false,
			responsive: { sizeColumn: 'full' },
			cell({ row }) {
				const {nombre, apellido1, apellido2} = row.original;
				return <CTNEllipsis content={getFullName(nombre, apellido1, apellido2)} />;
			},
		},
		{
			accessorKey: 'rol',
			header: 'Tipo',
			enableSorting: false,
			responsive: { sizeColumn: 'full' },
			th: {
				width: 160,
			},
			cell({ getValue }) {
				const value = getValue() as IUserListado['rol'];
				return <CTNEllipsis content={value.descripcion} />;
			},
		},
		{
			accessorKey: 'email',
			header: 'Correo electrónico',
			enableSorting: false,
			responsive: { sizeColumn: 'full' },
			th: {
				width: 300,
			},

			cell({ getValue }) {
				return <CTNEllipsis content={getValue() as string} />;
			},
		},
		{
			accessorKey: 'activo',
			header: 'Estado',
			enableSorting: false,
			th: {
				width: 100,
			},
			responsive: { sizeColumn: 'full' },
			cell({ getValue }) {
				return (
					<TextIcon
						description={(getValue() as boolean) ? 'Activo' : 'Inactivo'}
						iconLeft={
							(getValue() as boolean)
								? { icon: 'okCircle', color: 'green-40' }
								: { icon: 'koCircle', color: 'gray-50' }
						}
					/>
				);
			},
		},
		{
			accessorKey: 'actions',
			header: '',
			enableSorting: false,
			th: {
				width: 70,
			},
			td: {
				align: 'center',
			},
			responsive: { sizeColumn: 'full' },
			cell: ({ row }) => (
				<CTNButton
					variant="ghost"
					mode="secondary"
					size="size-32"
					label="Editar"
					onClick={() => onEdit(row.original)}
				/>
			),
		},
	];

	return columns;
};

export default getColumns;
